// Simple horizontal bar list — used for the subtype/category breakdown, where labels are long
// and a vertical bar chart's x-axis would be unreadable. CSS width-based bars, not SVG.
import { SERIES_COLORS } from './chartColors';

interface HorizontalBarChartProps {
  rows: { label: string; value: number }[];
}

export function HorizontalBarChart({ rows }: HorizontalBarChartProps) {
  if (rows.length === 0) {
    return <div className="text-sm text-slate-400 py-8 text-center">No data</div>;
  }
  const max = Math.max(1, ...rows.map((r) => r.value));
  return (
    <div className="space-y-2">
      {rows.map((r, i) => (
        <div key={r.label} className="flex items-center gap-3 text-sm">
          <span className="w-40 shrink-0 truncate text-slate-600" title={r.label}>
            {r.label}
          </span>
          <div className="flex-1 h-4 bg-slate-100 rounded overflow-hidden">
            <div
              className="h-full rounded"
              style={{ width: `${(r.value / max) * 100}%`, backgroundColor: SERIES_COLORS[i % SERIES_COLORS.length] }}
            />
          </div>
          <span className="w-10 shrink-0 text-right font-semibold text-slate-800 tabular-nums">{r.value}</span>
        </div>
      ))}
    </div>
  );
}
